import React, { useState } from "react";
// Importe o componente Sidebar aprimorado. Adapte o caminho conforme sua estrutura:
import Sidebar from "./Sidebar"; 

export default function AppLayout({ children }) {
// Mantemos o estado de abertura/fechamento
const [isSidebarOpen, setIsSidebarOpen] = useState(true);

// Assinatura para que a Sidebar funcione com o Layout
const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

return (
<div className="flex min-h-screen bg-slate-950">
 
 {/* 1. Sidebar - Usa o componente aprimorado */}
 {/* Passamos o estado 'isOpen' e a função 'toggleSidebar' para o componente Sidebar */}
 <Sidebar 
 initialOpen={isSidebarOpen} 
 toggleSidebar={toggleSidebar}
 />

 {/* 2. Conteúdo Principal */}
 <main className="flex-1 flex flex-col overflow-x-hidden">
 
 {/* Opcional: Aqui você pode adicionar um Header superior que não faz parte da sidebar, mas que sempre está visível. */}
 
 <div className="flex-1 overflow-y-auto">
 {children}
 </div>
 </main>
</div>
);
}